<template>
<div>
  <v-row class="no-gutters" justify="center" align="center" v-for="(narrador , n ) in dataNarradores" :key="'narrador-'+n" >
    <v-col cols="12" sm="3">
      <div class="cont-img">
        <v-img aspect-ratio="0.6" width="100%" :src="$store.state.rutaApi+narrador.foto"
        ></v-img>
      </div>
    </v-col>
    <v-col cols="12" sm="9" class="pa-3">
      <div class="cont-noticia">
        <h2 class="mb-2">{{narrador.titulo}}</h2>
        <p class="ma-0" v-html="narrador.texto"></p>
        <youtube width="100%" v-if="narrador.video"
        :video-id="''+narrador.video.split('/')[narrador.video.split('/').length - 1]+''" 
        ></youtube>
      </div>
    </v-col>
    <v-col cols="12" v-if="(n+1) <= (dataNarradores.length-1)">
      <v-divider class="my-2"></v-divider>
    </v-col>
  </v-row>
</div>
</template>
<script>
export default {
  props:{
    dataNarradores:{}
  },
  data() {
    return {
    }
  },
}
</script>
<style lang="scss" scoped>
.cont-img{
  border: solid 1px #0B542D;
  border-radius: 10px;
  padding: 10px;
}
.cont-noticia{
  // box-shadow: 0 0 10px rgba($color: #000000, $alpha: .4);
  // border: solid 1px #0B542D;
  border-radius: 10px;
  padding: 10px;
  h2{
    font-size: 1.1em;
  }
  p{
    font-size: 1em;
  }
}
</style>